import type { ApiErrorCode } from '@crew/shared';

/** שגיאה מה-API, עם קוד קבוע, הודעה בעברית ושגיאות לפי שדה (בטפסים). */
export class ApiClientError extends Error {
  readonly code: ApiErrorCode | 'network';
  readonly status: number;
  readonly retryAfter: number | undefined;
  readonly fields: Record<string, string> | undefined;
  constructor(
    code: ApiErrorCode | 'network',
    message: string,
    status: number,
    retryAfter?: number,
    fields?: Record<string, string>,
  ) {
    super(message);
    this.name = 'ApiClientError';
    this.code = code;
    this.status = status;
    this.retryAfter = retryAfter;
    this.fields = fields;
  }
}

export function errorMessage(err: unknown, fallback = 'הפעולה נכשלה. יש לנסות שוב'): string {
  return err instanceof Error && err.message ? err.message : fallback;
}
